<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
</head>

<br />
<br />
<button style="margin-left:95%" type="button" class="btn btn-warning btn-circle btn-lg" (click)="cancel()">
  <i class="fa fa-close"></i>
</button>

<div class="modal-body">
  <form #UpdlabForm="ngForm">
    <div class="form-group">
      <label for="sdate">Date of Analysis</label>
      <div class="input-group">
        <input class="form-control" placeholder="yyyy-mm-dd" name="sdate" [(ngModel)]="epresc.sdate" #sdate="ngModel"
          ngbDatepicker #dp="ngbDatepicker" [minDate]="minDate" />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary calendar" (click)="dp.toggle()" type="button"></button>
        </div>
      </div>
    </div>

    <div>
      <p align="center">
        Here comes the attachments - X-Ray / Scanning Reports
      </p>
    </div>

    <div class="form-group">
      <label for="medname">Title of Report</label>
      <div class="input-group">
        <input class="form-control" type="text" name="mname" [(ngModel)]="epresc.mname" #mname="ngModel" />
      </div>
    </div>
    <label for="medname">Report</label>
    <textarea required name="remarks" placeholder="" class="w-80 form-control "></textarea><br /><br />

    <button [disabled]="!UpdlabForm.valid" class="btn primary-btn" type="button" name="submit"
      (click)="Save(UpdlabForm.value)" (click)="cancel()">
      Update analysis
    </button>
  </form>
</div>